(function () {
  if (window.klaviyoBackInStockForm?.__amBound) return;

  var activeModal = null;
  var returnFocus = null;

  function parseVariants(modal) {
    var data = modal.querySelector('[data-am-klaviyo-bis-variants]');
    if (!data) return [];

    try {
      return JSON.parse(data.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function findModal(source) {
    var section = source?.closest?.('.shopify-section');
    var modal = section?.querySelector('[data-am-klaviyo-bis-modal]');
    if (modal) return modal;

    var sectionId = section?.id?.replace(/^shopify-section-/, '');
    if (sectionId) {
      modal = Array.from(
        document.querySelectorAll('[data-am-klaviyo-bis-modal]'),
      ).find(function (item) {
        return item.dataset.amKlaviyoBisSectionId === sectionId;
      });
    }

    return modal || document.querySelector('[data-am-klaviyo-bis-modal]');
  }

  function syncVariant(modal, source) {
    var section = source?.closest?.('.shopify-section');
    var idInput =
      source?.querySelector?.('form [name="id"]') ||
      section?.querySelector('product-form form [name="id"]') ||
      document.querySelector('product-form form [name="id"]');
    var variantId = idInput?.value;
    if (!variantId) return;

    var variantField = modal.querySelector('input[name="variant_id"]');
    if (variantField) variantField.value = variantId;

    var variant = parseVariants(modal).find(function (item) {
      return String(item.id) === String(variantId);
    });
    var title = variant?.title || '';
    var titleElement = modal.querySelector('[data-am-klaviyo-bis-variant]');
    var titleWrap = modal.querySelector('[data-am-klaviyo-bis-variant-wrap]');
    if (titleElement) titleElement.textContent = title;
    if (titleWrap) titleWrap.hidden = !title || title === 'Default Title';
  }

  function open(source) {
    var modal = findModal(source);
    if (!modal) return;

    syncVariant(modal, source);
    returnFocus = document.activeElement;
    activeModal = modal;
    /*
     * Product sections can create their own stacking contexts. Move the modal
     * directly under <body> so its fixed backdrop covers the header, drawers,
     * sticky bars, and every other page section.
     */
    document.body.appendChild(modal);
    modal.hidden = false;
    document.body.classList.add('am-klaviyo-bis-modal-open');

    var name = modal.querySelector('input[name="name"]');
    var email = modal.querySelector('input[name="email"]');
    var dialog = modal.querySelector('.am-klaviyo-bis-modal__dialog');
    requestAnimationFrame(function () {
      (name || email || dialog)?.focus?.();
    });
  }

  function close() {
    if (!activeModal) return;
    activeModal.hidden = true;
    document.body.classList.remove('am-klaviyo-bis-modal-open');
    activeModal = null;
    returnFocus?.focus?.();
    returnFocus = null;
  }

  function toE164Phone(raw) {
    var trimmed = (raw || '').trim();
    if (!trimmed) return '';
    var digits = trimmed.replace(/\D/g, '');
    if (trimmed.charAt(0) === '+') {
      return digits ? '+' + digits : '';
    }
    /* US/CA local numbers: 10 digits, or 11 with leading country code 1. */
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    if (digits.length >= 8 && digits.length <= 15) return '+' + digits;
    return '';
  }

  function splitName(fullName) {
    var parts = (fullName || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return null;
    if (parts.length === 1) return { first_name: parts[0] };
    return {
      first_name: parts[0],
      last_name: parts.slice(1).join(' '),
    };
  }

  /** Profile upsert accepts first_name; BIS subscription endpoint does not. */
  function upsertProfile(companyId, attributes) {
    return fetch(
      'https://a.klaviyo.com/client/profiles/?company_id=' +
        encodeURIComponent(companyId),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-10-15',
        },
        body: JSON.stringify({
          data: {
            type: 'profile',
            attributes: attributes,
          },
        }),
      },
    );
  }

  function submit(form) {
    var modal = form.closest('[data-am-klaviyo-bis-modal]');
    var nameField = form.querySelector('input[name="name"]');
    var emailField = form.querySelector('input[name="email"]');
    var phoneField = form.querySelector('input[name="phone"]');
    var variantField = form.querySelector('input[name="variant_id"]');
    var submitButton = form.querySelector('.klaviyo-bis-form__submit');
    var status = form.querySelector('.klaviyo-bis-form__status');
    var name = (nameField?.value || '').trim();
    var email = (emailField?.value || '').trim();
    var phoneRaw = (phoneField?.value || '').trim();
    var phone = phoneRaw ? toE164Phone(phoneRaw) : '';
    var variantId = variantField?.value;
    var companyId = modal?.dataset.klaviyoCompanyId;

    if (!email || !emailField.checkValidity()) {
      status.textContent = 'Please enter a valid email address.';
      status.dataset.state = 'error';
      emailField?.focus();
      return;
    }

    if (phoneRaw && !phone) {
      status.textContent = 'Please enter a valid phone number (include country code, e.g. +1…).';
      status.dataset.state = 'error';
      phoneField?.focus();
      return;
    }

    if (!companyId || !variantId) {
      status.textContent = 'Please select an unavailable option and try again.';
      status.dataset.state = 'error';
      return;
    }

    submitButton.disabled = true;
    status.textContent = 'Submitting...';
    status.dataset.state = '';

    /*
     * Client BIS profile only accepts email + phone_number (E.164).
     * first_name is rejected by Klaviyo on this endpoint.
     */
    var profileAttributes = { email: email };
    if (phone) profileAttributes.phone_number = phone;

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttributes,
            },
          },
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId,
            },
          },
        },
      },
    };

    function showSuccess() {
      status.textContent = "You're on the list! We'll email you when it is available.";
      status.dataset.state = 'success';
      submitButton.hidden = true;
      if (nameField) nameField.disabled = true;
      emailField.disabled = true;
      if (phoneField) phoneField.disabled = true;
    }

    fetch(
      'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' +
        encodeURIComponent(companyId),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2026-01-15',
        },
        body: JSON.stringify(payload),
      },
    )
      .then(function (response) {
        if (!response.ok) throw new Error('Klaviyo request failed');

        var nameParts = splitName(name);
        if (!nameParts) {
          showSuccess();
          return;
        }

        var upsertAttributes = Object.assign({ email: email }, nameParts);
        if (phone) upsertAttributes.phone_number = phone;

        return upsertProfile(companyId, upsertAttributes)
          .catch(function () {})
          .then(showSuccess);
      })
      .catch(function () {
        status.textContent = 'Something went wrong — please try again.';
        status.dataset.state = 'error';
        submitButton.disabled = false;
      });
  }

  document.addEventListener('click', function (event) {
    var closeButton = event.target.closest?.('[data-am-klaviyo-bis-close]');
    if (closeButton) {
      event.preventDefault();
      close();
      return;
    }

    var trigger = event.target.closest?.(
      'a.am-klaviyo-bis-proxy, a.klaviyo-bis-trigger',
    );
    if (trigger) {
      event.preventDefault();
      open(trigger);
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest?.('.klaviyo-bis-form__form');
    if (!form) return;
    event.preventDefault();
    submit(form);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && activeModal) close();
  });

  window.klaviyoBackInStockForm = {
    __amBound: true,
    open: open,
    close: close,
  };
})();
